import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Bug investigado (30/09/2026, pedido do Robson): "tela fica branca" ao salvar um cliente
// com e-mail em formato inválido. Causa raiz: quando o FastAPI/pydantic rejeita o corpo da
// requisição (422), `detail` vem como uma LISTA de objetos {loc, msg, type} — não uma
// string. O app inteiro segue o padrão `e?.response?.data?.detail` (~30 lugares) e passa
// isso direto pro toast (sonner), esperando uma string; ao tentar renderizar uma lista de
// objetos como filho, o React quebra com "Objects are not valid as a React child" — e como
// não existe nenhum Error Boundary no app (ver ErrorBoundary.jsx, adicionado agora como
// segunda camada de proteção), esse erro não tratado derruba a árvore inteira, deixando a
// tela em branco. Normaliza aqui, uma vez só, em vez de mexer em cada um dos ~30 lugares
// que leem esse campo — depois desse interceptor, `detail` chega sempre como string.
// Lote 157 — trabalhar no processo/agenda de um colega do escritório. O servidor guarda os dados de cada pessoa na
// conta dela; para abrir/editar o de um colega o app manda o cabeçalho X-Escritorio-Como com o id do dono. O servidor
// confere se vocês são do mesmo escritório e se o papel permite (e só aceita rotas de processo/agenda).
// De onde vem o dono: (1) listas do escritório registram quem é o dono de cada processo/compromisso (`registrarDonos`);
// (2) nas telas de detalhe, o `?de=` do endereço vale para tudo que a tela chamar (ex.: histórico, publicações).
const COMO = "X-Escritorio-Como";
const ROTAS_COMO = ["processos", "publications", "hearings", "clients", "prazos", "publicacoes"];
const donos = new Map();           // id do processo/compromisso → id do dono (só quando NÃO sou eu)
let donoDaTela = null;
const ehDetalhe = (path) => /^\/(processos|audiencia)\/[^/]+/.test(path || "");

export function registrarDonos(lista, meuId, campoId) {
  (lista || []).forEach((it) => {
    const id = it && it[campoId];
    if (!id) return;
    if (it.dono_id && it.dono_id !== meuId) donos.set(id, it.dono_id); else donos.delete(id);
  });
}
export const donoDe = (id) => donos.get(id) || null;
export const comoConfig = (donoId, meuId) => (donoId && donoId !== meuId ? { headers: { [COMO]: donoId } } : undefined);

function donoDaRota() {
  try {
    const de = new URLSearchParams(window.location.search).get("de");
    if (de) donoDaTela = de;
    else if (!ehDetalhe(window.location.pathname)) donoDaTela = null;
  } catch (e) { donoDaTela = null; }
  return ehDetalhe(window.location.pathname) ? donoDaTela : null;
}

http.interceptors.request.use((config) => {
  try {
    if (config.headers && config.headers[COMO]) return config;       // quem chamou já decidiu
    const url = String(config.url || "");
    const m = url.match(/^\/([^/?]+)(?:\/([^/?]+))?/);
    if (!m || !ROTAS_COMO.includes(m[1])) return config;
    const dono = (m[2] && donos.get(m[2])) || donoDaRota();
    if (dono) config.headers[COMO] = dono;
  } catch (e) { /* sem cabeçalho: vale a própria conta */ }
  return config;
});

http.interceptors.response.use(
  (response) => response,
  (error) => {
    // Cabeçalho "como colega" herdado da tela mas o item é meu: tenta de novo, sem ele.
    const cfg = error?.config;
    if (error?.response?.status === 404 && cfg && cfg.headers && cfg.headers[COMO] && !cfg._semComo) {
      cfg._semComo = true;
      delete cfg.headers[COMO];
      return http.request(cfg);
    }
    const detail = error?.response?.data?.detail;
    if (Array.isArray(detail)) {
      const msg = detail.map((d) => (d && d.msg) || String(d)).join("; ");
      error.response.data.detail = msg || "Dados inválidos";
    }
    return Promise.reject(error);
  }
);
